module.exports = __webpack_public_path__ + "static/media/blog.5bb37441.jpg";